import { c as _c } from "react/compiler-runtime";
import { ItemImage } from '@sbt-web/network/types';
import { DeviceWidth } from '@sbt-web/ui';
import cn from 'classnames';
import styles from './index.module.scss';
type Props = {
  fullScreen?: boolean;
  image: ItemImage;
  isFirstImage: boolean;
  reduceDataUse?: boolean;
  shouldSkipLazyLoading: boolean;
  alt: string;
};
const mobileRule = 'gallery-mobile';
const desktopRule = 'gallery-desktop';
const galleryRule = 'fullscreen';
const buildSrcSet = (cdnBaseUrl: string, ruleQuery: string) => `${cdnBaseUrl}?rule=${ruleQuery}-1x-auto 1x, ${cdnBaseUrl}?rule=${ruleQuery}-2x-auto 2x, ${cdnBaseUrl}?rule=${ruleQuery}-3x-auto 3x`;
const CarouselPicture = t0 => {
  const $ = _c(27);
  const {
    fullScreen,
    image,
    isFirstImage,
    reduceDataUse,
    shouldSkipLazyLoading,
    alt
  } = t0;
  let t1;
  if ($[0] !== image.cdnBaseUrl) {
    t1 = buildSrcSet(image.cdnBaseUrl, galleryRule);
    $[0] = image.cdnBaseUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const fullScreenSrcSet = t1;
  let t2;
  if ($[2] !== fullScreen || $[3] !== fullScreenSrcSet || $[4] !== image.cdnBaseUrl) {
    t2 = fullScreen ? fullScreenSrcSet : buildSrcSet(image.cdnBaseUrl, desktopRule);
    $[2] = fullScreen;
    $[3] = fullScreenSrcSet;
    $[4] = image.cdnBaseUrl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const desktopSrcSet = t2;
  let t3;
  if ($[6] !== fullScreen || $[7] !== fullScreenSrcSet || $[8] !== image.cdnBaseUrl) {
    t3 = fullScreen ? fullScreenSrcSet : buildSrcSet(image.cdnBaseUrl, mobileRule);
    $[6] = fullScreen;
    $[7] = fullScreenSrcSet;
    $[8] = image.cdnBaseUrl;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const mobileSrcSet = t3;
  let t4;
  if ($[10] !== fullScreen) {
    t4 = cn({
      [styles["full-screen-picture"]]: fullScreen
    });
    $[10] = fullScreen;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== desktopSrcSet) {
    t5 = <source srcSet={desktopSrcSet} media={`(min-width: ${DeviceWidth.tablet.min})`} />;
    $[12] = desktopSrcSet;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = `${image.cdnBaseUrl}?rule=${mobileRule}-1x-auto`;
  const t7 = reduceDataUse ? undefined : mobileSrcSet;
  const t8 = isFirstImage ? alt : "";
  let t9;
  if ($[14] !== fullScreen) {
    t9 = cn(styles.image, {
      [styles["full-screen-img"]]: fullScreen
    });
    $[14] = fullScreen;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = isFirstImage || shouldSkipLazyLoading ? "eager" : "lazy";
  const t11 = isFirstImage ? "high" : "low";
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t12 = <img src={t6} srcSet={t7} alt={t8} className={t9} decoding="async" loading={t10} fetchPriority={t11} />;
    $[16] = t10;
    $[17] = t11;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t4 || $[25] !== t5) {
    t13 = <picture className={t4}>{t5}{t12}</picture>;
    $[23] = t12;
    $[24] = t4;
    $[25] = t5;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
export default CarouselPicture;